import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { Stack, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Icon } from '@feathr/components';
import Page from '@feathr/extender/App/Page';

import GoalManagerStats from './GoalManagerStats';
import GoalManagerTable from './GoalManagerTable';
import { useGoalManagerPage } from './ReportsConversionsGoalManagerPage.hooks';
import { hasAnyGoals } from './ReportsConversionsGoalManagerPage.utils';

function ReportsConversionsGoalManagerPage(): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const { activeCount, archivedCount, filteredGoals, goals, search, setSearch, setTab, tab } =
    useGoalManagerPage();

  return (
    <Page
      actions={[
        <Button key={'create-goal'} prefix={<Icon icon={faPlus} />} type={'primary'}>
          {t('Create goal')}
        </Button>,
      ]}
      collapseHeader={false}
      title={t('Goal Manager')}
    >
      <Stack gap={theme.spacing['6']}>
        {hasAnyGoals(goals) && (
          <GoalManagerStats activeCount={activeCount} archivedCount={archivedCount} />
        )}
        <GoalManagerTable
          filteredGoals={filteredGoals}
          goals={goals}
          search={search}
          setSearch={setSearch}
          setTab={setTab}
          tab={tab}
        />
      </Stack>
    </Page>
  );
}

export default observer(ReportsConversionsGoalManagerPage);
